import * as React from "react";
import UploadFiles from "./UploadFiles";
import Input from "../Input-new/Input";
import Textarea from "../Textarea-new/Textarea";
import Checkbox from "../CheckboxNew/Checkbox";

const employeeForms = [
  {
    label: "Photo",
    name: "photo",
  },
];

const TeamMemberWebsite = ({
  isDisabled,
  data,
  handleChangeInput,
  handleChangeFile,
  viewMode,
  deleted,
}) => {
  return (
    <div className="Team-member-info">
      <div className="Team-member-info_column">
        <Checkbox
          text="VISIBLE"
          type={viewMode || data.is_agent === "i" ? "uncheckable" : "checkable"}
          isSelected={data.visible_on_website}
          handleClick={handleChangeInput}
          name="visible_on_website"
        />
        {data.is_agent === "i" && (
          <Checkbox
            text="VISIBLE IN BOV"
            type={viewMode ? "uncheckable" : "checkable"}
            isSelected={data.visible_on_bov}
            handleClick={handleChangeInput}
            name="visible_on_bov"
          />
        )}
        <Input
          className="Team-member-info_column_item"
          valueType="text"
          name="title"
          label="Title"
          value={data.title}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Team-member-info_column_item"
          valueType="text"
          name="linkedin"
          label="Linkedin"
          value={ viewMode ?<a className="green" target="_blank" href={data.linkedin}>
                    {data.linkedin}
                </a>
            :
            data.linkedin}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <UploadFiles
          classNames="Team-member-info_column_item"
          data={data}
          viewMode={viewMode}
          deleted={deleted}
          handleChangeFile={handleChangeFile}
          initialFilesAmount={1}
          maxFilesAmount={1}
          items={employeeForms}
          // disabled={isDisabled}
          handleChangeInput={handleChangeInput}
          fileType={"photo"}
        />
        <Textarea
          className="Team-member-info_column_item"
          name="description"
          label="Bio"
          value={data.description}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
          isList={true}
        />
      </div>
    </div>
  );
};

export default TeamMemberWebsite;
